<template>
  <div class="about-us">
    <PopupModal v-if="show" @closePopup="handlePopup" />
    <div class="container mx-auto flex lg:flex-row flex-col  lg:py-16 py-10 px-3 gap-8">
      <div class="lg:w-1/2 lg:py-10 py-5 overflow-hidden lg:h-auto sm:min-h-[400px] min-h-[300px] w-full">
        <div class="flex justify-start w-full relative ">
          <div class="bg-secondary z-10 w-[150px] h-[150px]"></div>
          <img src="../../assets/v-1.1/about-us-plumbing.webp" alt="Plumbing"
            class="absolute top-5 left-5 z-20 max-h-[250px] max-w-[70%]" />
          <img src="../../assets/v-1.1/about-us-heating.webp"
            class="absolute lg:top-[250px] top-[100px] left-[40%] z-30 max-h-[250px] max-w-[70%] border-4 broder-white"
            alt=" Plumbing" />
        </div>
      </div>
      <div class="lg:w-1/2 lg:p-10">
        <div class="flex flex-col justify-center lg:justify-start items-start lg:gap-5  gap-3">
          <div class="text-primary font-primary uppercase font-semibold">About Us</div>
          <h2 class="text-3xl font-bold font-primary">
            Expert Team of Licensed and Master Plumbers in the GTA
          </h2>
          <div class="text-grey">
            Gill Brother Plumbing and Heating Ltd. serves the GTA with a team of highly experienced, dedicated, master, and licensed plumbers. We are prepared for all commercial and residential plumbing projects. We are committed to providing top-notch quality services such as residential and commercial plumbing work, custom home plumbing, legal basement contracting, radiant floor heating, bathroom renovations, water main upgrades, drain and sewer replacement, camera inspections, and fire sprinkler installation, among others. We are open to all types of renovations and new construction. The reputation of our qualified, licensed, and masterfully professional in-house team of plumbers proves why we are the number one choice for our customers any day of the week.

          </div>
          <div class="border-l-4 border-secondary font-bold px-2 my-1">
            When it comes to plumbing and heating, we are the undisputed champions of excellence. With over 10 years of
            unparalleled experience, we proudly stake our claim as your number one professional choice.
          </div>
          <div
            class="bg-primary p-5 gap-2 flex md:flex-row flex-col text-center lg:text-left justify-around w-full items-center">
            <div class="text-white">
              <span class=" font-primary">Call Us at</span>
              <a href="tel:6478958107"
                class="py-2 px-3 mt-2 border border-white flex justify-center group hover:bg-secondary duration-400 hover:border-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="white">
                  <path
                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span class="ml-3 group-hover:text-white">6478958107</span>
              </a>
            </div>
            <div class="text-white font-bold">
              or
            </div>
            <div>
              <RequestService @closePopup="handlePopup" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import RequestService from "./RequestService.vue";
const show = ref(false);
const handlePopup = () => {
  show.value = !show.value;
};
</script>

<style scoped>
.about-us {
  background-image: url("../../assets/v-1.1/aboutus-banner.webp");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>